module.exports = __webpack_public_path__ + "img/services1.65a5d2cc.jpg";